var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"saas-section saas-section--dark-to-light",class:{
    'saas-section--gray': _vm.block.background === 'gray',
    'saas-section--light-to-dark': _vm.block.background === 'light_to_dark',
    'saas-section--dark-to-light': _vm.block.background === 'dark_to_light',
  }},[(_vm.block.title)?_c('div',{staticClass:"saas-section__title saas-section__title--wide"},[_c('h2',{staticClass:"saas-striped-title"},[_vm._v(_vm._s(_vm.block.title))])]):_vm._e(),_vm._v(" "),_c('PageHorizontalMessages',{attrs:{"message-rows":_vm.block.messages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }